"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.StringFormatRule = void 0;
var validation_rule_1 = require("./validation-rule");
var StringFormatRule = /** @class */ (function (_super) {
    __extends(StringFormatRule, _super);
    /**
     * Creates a rule that validates that a string property value is correctly formatted.
     * @param rootType The model type the rule is for.
     * @param options The options for the rules.
     */
    function StringFormatRule(rootType, options) {
        var _this = this;
        // exit immediately if called with no arguments
        if (arguments.length > 0) {
            // ensure the rule name is specified
            options.name = options.name || "StringFormat";
            // see if the error message is a valid resource: {resource-name}
            if (typeof options.message === "string" && rootType.model.resourceExists(options.message)) {
                var message_1 = options.message;
                options.message = function () { return rootType.model.getResource(message_1); };
            }
            // get the default validation message if not specified
            if (!options.message) {
                options.message = function () { return rootType.model.getResource("string-format").replace("{formatDescription}", options.description); };
            }
            var expression_1 = options.expression instanceof RegExp ? options.expression : RegExp(options.expression);
            var reformat_1 = options.reformat;
            // create the string format validation function
            options.isValid = function (prop, val) {
                var isValid = true;
                if (val && val !== "") {
                    expression_1.lastIndex = 0;
                    isValid = expression_1.test(val);
                    if (isValid && options.reformat) {
                        if (reformat_1 instanceof Function) {
                            val = reformat_1(val);
                        }
                        else {
                            expression_1.lastIndex = 0;
                            val = val.replace(expression_1, reformat_1);
                        }
                        prop.value(this, val);
                    }
                }
                return isValid;
            };
        }
        // call the base type constructor
        _this = _super.call(this, rootType, options) || this;
        // define properties for the rule
        _this.description = options.description;
        return _this;
    }
    // get the string representation of the rule
    StringFormatRule.prototype.toString = function () {
        return this.property.containingType.fullName + "." + this.property.name + " formatted as " + this.description;
    };
    return StringFormatRule;
}(validation_rule_1.ValidationRule));
exports.StringFormatRule = StringFormatRule;
